import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline'
import { Box } from '@mui/material'
import DialogTitle from '@mui/material/DialogTitle'
import { styled } from '@mui/material/styles'

export const AddIcon = styled(AddCircleOutlineIcon)(({ theme }) => ({
  marginRight: theme.spacing(1),
  color: theme.colors.primary.slalomBlue,
}))

export const PhotoCaption = styled(DialogTitle)(({ theme }) => ({
  fontSize: theme.typography.body2.fontSize,
}))

export const PaddedContainer = styled(Box)(({ theme }) => ({
  flexGrow: 1,
  padding: theme.spacing(3),
}))

export const AddPhotoContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  cursor: 'pointer',
  '&:hover': {
    opacity: 0.7,
  },
}))

export const GridImageWrapper = styled('div')(({ theme }) => ({
  position: 'relative',
  width: '100%',
  height: '200px',
  borderRadius: theme.spacing(1),
  overflow: 'hidden',
  cursor: 'pointer',

  '&:hover .overlay': {
    opacity: 1,
  },
}))

export const GridImage = styled('img')(({ theme }) => ({
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  display: 'block',
}))

export const Overlay = styled('div')({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  background: '#002FAF80',
  backdropFilter: 'blur(8px)',
  opacity: 0,
  transition: 'opacity 0.3s ease-in-out',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
})
